/*
 * @Description: 微扬官网中文语言包
 * @Author: pliybird
 * @Date: 2023-05-26 15:44:31
 * @LastEditTime: 2025-11-10 14:26:37
 * @LastEditors: pliybird
 * @filePath: Do not edit
 */
const home = require("./home.json");
const solution = require("./solution.json");
const solution_crm = require("./solution_crm.json");
const product = require("./product.json");
const service = require("./service.json");
const cases = require("./cases.json");
const news = require("./news.json");
const overseas = require("./overseas.json");
const about_us = require("./about_us.json");
const pp_services = require("./pp_services.json");

export default {
  language: "中文",
  feedback: {
    scrollTop: {
      tab01: "微信扫码，在线咨询",
      tab02: "联系我们",
      tab03_1: "业务咨询",
      tab03_2: "提交信息后我们将第一时间联系您",
    },
    form: {
      title: "业务咨询",
      form_fullname: "姓名（必填）",
      form_telephone: "联系电话（必填）",
      form_emailAddress: "电子邮箱",
      form_tip1: "输入的电子邮箱格式不正确",
      form_captcha: "图形验证码（必填）",
      form_tip2: "请输入正确的验证码",
      form_companyName: "公司全称（必填）",
      form_companyLocation: "公司所在地",
      form_customerIndustry: "所属行业",
      form_customerBudget: "预算需求",
      form_consultDetails: "业务咨询（必填）",
      form_choose: "请选择",
      form_btn: "提交",
      form_success: "信息提交成功",
    },
  },
  footer: {
    contact: "售前咨询",
    fllow: "关注汉得微扬",
    wechat_account: "汉得微扬Vyung",
    wechat_channel: "汉得微扬官方视频号",
    about_vyung: "关于汉得微扬",
    company_info: "公司信息",
    offices: "办事处",
    news: "新闻",
    links: "友情链接",
    hand: "汉得信息",
    hellos: "汇联易",
    dingyi: "鼎医信息",
    more: "更多推荐",
    cases: "客户案例",
    copyright: "上海汉得微扬信息技术有限公司",
    hand_us: "汉得美国",
    hand_jp: "汉得日本",
    hand_eu: "汉得欧洲",
    hand_sg: "汉得新加坡",
  },
  home: home,
  solution: solution,
  solution_crm: solution_crm,
  product: product,
  service: service,
  cases: cases,
  news: news,
  overseas: overseas,
  about_us: about_us,
  pp_services,
};
